import axios from 'axios';
import { makeApiUrl } from '../../../shared/util';
import { SignupRequestBody, SignupResponseBody } from '../type';

export const postSignup = (form: SignupRequestBody) => {
  return axios.post<SignupResponseBody>(makeApiUrl('/:lang/@api/signup', { lang: ET.lang }), form);
};
